import React from 'react'
import {
  Box,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Divider,
  Button,
} from '@mui/material'
import { ArrowBack as ArrowBackIcon, Shield as ShieldIcon } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'
import CustomerLayout from '@/components/Layout/CustomerLayout'

export const TokushohonPage: React.FC = () => {
  const navigate = useNavigate()

  const legalItems = [
    { label: '販売事業者名', value: 'HighLandirect 運営事務局 / 株式会社ハイランド' },
    { label: '運営統括責任者', value: '山田 太郎' },
    { label: '所在地', value: '〒100-0001 東京都千代田区丸の内1-1-1' },
    { label: '電話番号', value: '03-1234-5678（受付時間：平日 9:00〜18:00）' },
    { label: 'メールアドレス', value: 'support@highlandirect.example.com' },
    { label: '販売価格', value: '各商品ページおよびご注文最終確認画面に表示（表示価格は消費税込み価格です）' },
    {
      label: '商品代金以外の必要料金',
      value: (
        <Box>
          <Typography variant="body2" paragraph>
            <strong>配送料金（税込）：</strong> お届け先地域および商品の合計重量（3kg / 5kg / 10kg / 20kg等）に応じて算出されます。
          </Typography>
          <Typography variant="caption" color="text.secondary">
            ※ 関東・甲信越：800円〜 / 東北・関西：900円〜 / 北海道・九州：1,200円〜 / 沖縄：1,500円〜（ご注文確定前の画面にて自動計算し提示いたします）
          </Typography>
        </Box>
      ),
    },
    {
      label: 'お支払い方法・決済時期',
      value: (
        <Box>
          <Typography variant="body2" paragraph>
            <strong>クレジットカード決済（Stripe Checkout）</strong>
          </Typography>
          <Typography variant="body2" paragraph color="primary.main" fontWeight={600}>
            【オーソリ・仮売上（与信確保）方式を採用】
          </Typography>
          <Typography variant="body2" color="text.secondary">
            ご注文手続き完了時に、お客様のクレジットカードの与信枠確保（仮売上）のみを行います。<br />
            <strong>実際の引き落とし（本決済・実売上）は、商品の発送手続き完了またはお届け時</strong>に実行されます。
          </Typography>
        </Box>
      ),
    },
    { label: '商品の引き渡し時期', value: 'ご注文（与信確保）確認後、通常2〜5営業日以内に発送いたします。' },
    {
      label: '返品・交換・キャンセルについて',
      value: (
        <Box>
          <Typography variant="body2" paragraph>
            <strong>【商品発送前のキャンセル】</strong><br />
            発送前のキャンセルにつきましては、手数料無料で即座に与信枠（仮売上）の開放手続きを行います。
          </Typography>
          <Typography variant="body2">
            <strong>【商品発送後・到着後の返品・交換】</strong><br />
            食品・生鮮品の性質上、お客様ご都合による出荷後の返品・返金はお受けできません。<br />
            万一、届いた商品に破損や不良・品違いがございました場合は、商品到着後2日以内に上記お問い合わせ窓口までご連絡ください。良品と交換または返金対応させていただきます。
          </Typography>
        </Box>
      ),
    },
  ]

  return (
    <CustomerLayout>
      <Box sx={{ maxW: 900, mx: 'auto' }}>
        <Button startIcon={<ArrowBackIcon />} onClick={() => navigate('/checkout')} sx={{ mb: 2 }}>
          ご注文画面へ戻る
        </Button>

        <Paper elevation={0} sx={{ p: 4, borderRadius: 3, border: '1px solid #e2e8f0' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
            <ShieldIcon color="primary" sx={{ fontSize: 32 }} />
            <Typography variant="h5" fontWeight={700}>
              特定商取引法に基づく表記
            </Typography>
          </Box>
          <Typography variant="body2" color="text.secondary" paragraph>
            「特定商取引に関する法律」第11条（通信販売についての広告）および改訂第12条の6に基づき、以下の通り開示いたします。
          </Typography>

          <Divider sx={{ my: 3 }} />

          <TableContainer>
            <Table>
              <TableBody>
                {legalItems.map((item, idx) => (
                  <TableRow key={idx} sx={{ '&:nth-of-type(odd)': { backgroundColor: '#f8fafc' } }}>
                    <TableCell
                      component="th"
                      scope="row"
                      sx={{ width: '30%', fontWeight: 700, verticalAlign: 'top', borderBottom: '1px solid #e2e8f0', py: 2.5 }}
                    >
                      {item.label}
                    </TableCell>
                    <TableCell sx={{ width: '70%', borderBottom: '1px solid #e2e8f0', py: 2.5 }}>
                      {typeof item.value === 'string' ? <Typography variant="body2">{item.value}</Typography> : item.value}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </Box>
    </CustomerLayout>
  )
}
export default TokushohonPage
